import { render } from "./ExamQuestionItem.vue?vue&type=template&id=1a6fe767&scoped=true"
import script from "./ExamQuestionItem.vue?vue&type=script&lang=js"
export * from "./ExamQuestionItem.vue?vue&type=script&lang=js"

import "./ExamQuestionItem.vue?vue&type=style&index=0&id=1a6fe767&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6fe767"]])

export default __exports__